import React from 'react'
import { Dropdown } from 'antd'
import styles from './style.module.scss'

// 연결되지 않은 열은 말없이 버려지므로 알리고(spec D14), 열마다 타입을 골라 필드로 추가할 수 있게 한다.
// 타입 목록은 기존 '필드 추가' 와 같은 것을 쓰도록 호출측이 만든 메뉴 생성 함수를 받는다
const UnmappedColumnsNotice = ({
  unmappedColumns,
  translateColumn,
  buildFieldTypeMenuItems,
  onAddAsField,
  t,
}) => (
  <div className={styles.unmappedNotice} role="note">
    <p className={styles.title}>
      {t('record.import.v2.mapping.unmappedTitle', { count: unmappedColumns.length })}
    </p>
    <ul className={styles.columnList}>
      {unmappedColumns.map((column) => (
        <li key={column} className={styles.columnItem}>
          <span className={styles.columnName} title={translateColumn(column)}>
            {translateColumn(column)}
          </span>
          {/* trigger 를 명시한다 — antd Dropdown 의 기본은 hover 라 클릭만으로는 열리지 않는다 */}
          <Dropdown
            menu={{ items: buildFieldTypeMenuItems((type) => onAddAsField(column, type)) }}
            trigger={['click']}
            placement="bottomLeft"
            overlayClassName="contextMenu"
          >
            <button type="button" className={styles.addAsFieldBtn}>
              {t('record.import.v2.mapping.addAsField')}
            </button>
          </Dropdown>
        </li>
      ))}
    </ul>
    <p className={styles.hint}>{t('record.import.v2.mapping.addAsFieldHint')}</p>
  </div>
)

export default UnmappedColumnsNotice
